// frontend/src/components/Auth/PermissionGuard.jsx
// DEBUG VERSION — remove console logs once working

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../context/PermissionsContext';

const PermissionGuard = ({ menuKey, operation = 'read', children, fallback }) => {
  const { can, loading, ready, error } = usePermissions();
  const location = useLocation();
  const allowed = can(menuKey, operation);

  console.log(
    `[PermissionGuard] menuKey='${menuKey}' op='${operation}'`,
    '| loading:', loading,
    '| allowed:', allowed,
    '| error:', error ?? 'none',
    '| path:', location.pathname
  );

  // Wait until permissions are both fetched AND from an authenticated load
  if (loading || !ready) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
      height:'100%', padding:40, color:'var(--gray-400)', fontSize:13 }}>
      A verificar permissões…
    </div>
  );

  // If permissions failed to load, allow through rather than permanently blocking
  if (error) {
    console.error('[PermissionGuard] Permissions failed to load — rendering anyway:', error);
    return children;
  }

  if (!allowed) {
    if (fallback) return fallback;
    return <Navigate to="/forbidden" state={{ from: location, menuKey, operation }} replace />;
  }

  return children;
};

export default PermissionGuard;